<template>
    <div class="animated fadeIn" :key="$router.currentRoute.params.userId">
        <Spinner v-if="user.loading" />
        <div v-if="!user.loading" :key="curKey">
            <b-row>
                <b-col sm="12" md="4" offset-md="0">
                    <GeneralInformation
                        v-if="!user.loading"
                        class="animated fadeIn"
                        :userId="userId"
                        :user="user"
                        @change="handleChange"
                        :can-edit="canEdit"
                    />
                </b-col>
                <b-col sm="12" md="4" offset-md="0">
                    <EmailAddresses
                        v-if="user.company_id"
                        :user="user"
                        :edit-enabled="canEdit && authIsManager"
                    />
                    <Account
                        :user="user"
                        :key="curKey"
                        @change="handleChange"
                        :can-edit="canEdit"
                        :edit-enabled="canEdit"
                    />
                </b-col>

                <b-col sm="12" md="4">
                    <Roles
                        :user="user"
                        :edit-enabled="canEdit"
                        v-if="authIsManager"
                        @change="handleChange"
                    />
                    <UserGroups :user="user" :edit-enabled="canEdit" />
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import GenericModel from '@/models/GenericModel'
import GenericCollection from '@/models/GenericCollection'

import Spinner from 'vue-spinner-component/src/Spinner'

import EmailAddresses from './__partials__/EmailAddresses'

import GeneralInformation from './__partials__/GeneralInformation'
import UserGroups from './__partials__/UserGroups'
import Roles from './__partials__/Roles'
import Account from './__partials__/Account'

import { mapMutations, mapGetters } from 'vuex'

export default {
    components: {
        Spinner,
        EmailAddresses,
        GeneralInformation,
        UserGroups,
        Roles,
        Account,
    },
    props: {},
    data() {
        return {
            userId: this.$route.params.userId,
            user: this.$resource('users', {
                id: this.$route.params.userId,
            }),

            groups: new GenericCollection().setResourceName('groups'),
            company: new GenericModel(),
            usertypes: [],
            modalVisible: false,
            activeGroup: '',
            curKey: 0,
        }
    },
    created() {
        this.user.setIncludes('department,usertype,role,emailaddresses')

        this.user.fetch()
        this.setCompany(this.$route.params.orgId)
        window.user = this.auth_user
        window.target = this.user
        //this.userInit(this.user)
    },
    methods: {
        ...mapMutations({
            setCompany: 'companies/setCompany',
        }),

        usertypeChanged(usertype) {
            this.user.usertype_id = usertype.id
        },

        roleChanged(role) {
            this.user.role_id = role.id
        },

        handleChange(user) {
            console.log('handleChange', user)
            this.user = Object.assign(this.user, user)
            console.log(this.user)
            this.curKey = this.curKey + 1
        },

        showModal() {
            this.modalVisible = true
            let ref = this.$refs.addGroupMemberModal
            if (typeof ref != 'undefined') {
                ref.show()
            }
            return true
        },

        hideModal() {
            this.modalVisible = false
            let ref = this.$refs.addGroupMemberModal
            if (typeof ref != 'undefined') {
                ref.hide()
            }
        },
    },
    computed: {
        ...mapGetters({
            auth_user: 'auth/user',
            roles: 'roles/roles',
            authIsManager: 'auth/isManager',
            authIsCompanyAdmin: 'auth/isCompanyAdmin',
            authIsGlobalAdmin: 'auth/isGlobalAdmin',
        }),

        canEdit() {
            let target = this.user
            let user = this.auth_user

            // Return true if global admin or company-admin
            if (this.authIsGlobalAdmin || this.authIsCompanyAdmin) return true

            // Return true if current user is the same as target user
            if (user.id == target.id) return true

            // Return false if the current user has a lower rank than target
            if (user.role.rank > target.role.rank) return false

            // Returns true
            let authUserHasManagedUnits = user.manager_unit_accesses
                .map(u => u.unit_id)
                .includes(target.department_id)

            if (
                this.authIsManager &&
                (user.department_id == target.department_id ||
                    authUserHasManagedUnits)
            )
                return true

            // Default false
            return false
        },

        onlyVisibleGroups() {
            let groups = this.groups
            groups = groups.filter(p => {
                return p._attributes.group !== null
            })
            if (groups.length == 0) {
                groups.loading = false
            }

            return groups
        },
    },
    filters: {},
}
</script>
